
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import SsComponentPage from "@/report/pages/SsComponentPage.vue"
import RetirementAdequacyChart from "@/superannuation/RetirementAdequacyChart.vue"

@Component({
  name: "SsRetirementPage",
  components: {
    SsComponentPage,
    RetirementAdequacyChart,
  },
})
export default class SsRetirementPage extends AbstractPage {}
